import { RA } from "@scripts/fp-ts";
import type { HrefLocationU } from "@scripts/generated/domaintables/hrefLocations";
import type { Href } from "@scripts/generated/models/href";
import type { WithStatusU } from "@scripts/generated/models/threadThrough";

export const filterByHrefLocation = (loc: HrefLocationU): (hrefs: ReadonlyArray<WithStatusU<Href>>) => ReadonlyArray<WithStatusU<Href>> =>
  RA.filter(_ => _.data.record.location._tag === loc._tag);
